import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environmentOm } from './environment-om';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environmentOm.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
    .catch(err =>
        // tslint:disable-next-line:no-console
        console.log(err)
    );
